import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { GameDetailsComponent } from './game-details.component';
import { SwiperModule } from "swiper/angular";

@NgModule({
  declarations: [
    GameDetailsComponent
  ],
  imports: [
    SwiperModule,
    CommonModule,
    IonicModule,
    ComponentsModule,
  ]
})
export class GameDetailsModule {}
